/* ============================================================
   VOMAIRE Cart Drawer + Sticky ATC
   Works alongside Impulse theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ---------- config injected by Liquid ---------- */
  var CFG = window.VOMAIRE_CFG || {};
  var BUNDLE = (CFG.bundle && CFG.bundle.length) ? CFG.bundle : [
    { qty: 2, off: 10 }, { qty: 3, off: 20 }, { qty: 4, off: 30 }
  ];
  var MONEY_FORMAT = CFG.moneyFormat || '${{amount}}';

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, s.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fetchJSON(url, opts) { return fetch(url, opts).then(function (r) { return r.json(); }); }

  /* ---------- bundle discount math ---------- */
  function discountFor(qty) {
    var off = 0, label = null, next = null;
    BUNDLE.forEach(function (t) { if (qty >= t.qty) { off = t.off; label = t.qty; } });
    for (var i = 0; i < BUNDLE.length; i++) { if (qty < BUNDLE[i].qty) { next = BUNDLE[i]; break; } }
    return { off: off, label: label, next: next };
  }
  var DEFAULT_MSGS = [
    "You\u2019re NEED away from NEXTOFF% off \u2014 don\u2019t leave that on the table",
    "Great choice! Add NEED more to unlock NEXTOFF% off \u2014 treat yourself, you deserve it",
    "Almost there! Just NEED more to unlock our biggest savings \u2014 NEXTOFF% off everything",
    "You\u2019ve unlocked our biggest discount \u2014 OFF% off your entire order"
  ];
  function nonEmpty(arr, fallback) {
    if (!arr || !arr.length) return fallback;
    return arr.map(function(v, i) { return (v && v.length) ? v : fallback[i]; });
  }

  function bundleProgressHTML(cart, compact) {
    var qty = cart.item_count;
    var disc = discountFor(qty);
    var tierLabels = nonEmpty(CFG.cartTierLabels, ['10% OFF','20% OFF','30% OFF']);
    var msgs = nonEmpty(CFG.cartMessages, DEFAULT_MSGS);
    var msg, tierIndex = -1;
    BUNDLE.forEach(function(t, i) { if (qty >= t.qty) tierIndex = i; });
    if (!disc.next) {
      msg = msgs[msgs.length - 1].replace('OFF', disc.off);
    } else {
      var need = disc.next.qty - qty;
      var mi = Math.max(0, Math.min(tierIndex + 1, msgs.length - 2));
      msg = msgs[mi].replace('NEED', need).replace('NEXTOFF', disc.next.off);
    }
    var DOT_MAX = 88; /* max % position so dots don't hit the right edge */
    var dots = BUNDLE.map(function(t, i) {
      var active = qty >= t.qty;
      var pos = ((i + 1) / BUNDLE.length) * DOT_MAX;
      return '<div class="bprog__dot" style="left:' + pos + '%">' +
        '<div class="bprog__dot-circle ' + (active ? 'active' : '') + '">' +
          (active ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M5 12l5 5L19 7"/></svg>' : '') +
        '</div>' +
        '<span class="bprog__dot-label">' + tierLabels[i] + '</span>' +
      '</div>';
    }).join('');
    var maxQty = BUNDLE[BUNDLE.length - 1].qty;
    var pct = Math.min(100, (qty / maxQty) * 100);
    return '<div class="bprog bprog--clean' + (compact ? ' bprog--mini' : '') + '">' +
      '<div class="bprog__msg">' + msg + '</div>' +
      '<div class="bprog__bar-wrap">' +
        '<div class="bprog__track"><div class="bprog__fill" style="width:' + pct + '%"></div></div>' +
        dots +
      '</div>' +
    '</div>';
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = qs('#vomToast'); if (!t) return;
    qs('#vomToastMsg').textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__vtt);
    window.__vtt = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  function setCounts(n) {
    qsa('[data-bag-count]').forEach(function (e) { e.textContent = n; });
    var dc = qs('#cartDrawerCount');
    if (dc) dc.textContent = n ? n + (n === 1 ? ' piece' : ' pieces') : '';
    /* also update Impulse cart bubble */
    var bubble = qs('.cart-link__bubble');
    if (bubble) {
      if (n > 0) bubble.classList.add('cart-link__bubble--visible');
      else bubble.classList.remove('cart-link__bubble--visible');
    }
  }

  function drawerLine(item) {
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var compareAt = item.original_price > item.final_price ? '<s>' + money(item.original_price) + '</s> ' : '';
    return '<div class="cdl" data-key="' + item.key + '">' +
      '<a href="' + item.url + '"><img class="cdl__img" src="' + img + '" alt="' + item.product_title + '" /></a>' +
      '<div class="cdl__main">' +
        '<div class="cdl__top"><div class="cdl__name">' + item.product_title + '</div>' +
        '<button class="cdl__trash" data-cd-remove="' + item.key + '" aria-label="Remove"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14"/></svg></button></div>' +
        (variant ? '<div class="cdl__meta">' + variant + '</div>' : '') +
        '<div class="cdl__price">' + compareAt + money(item.final_price) + '</div>' +
        '<div class="cdl__ctrls">' +
          '<div class="qty"><button data-cd-qty="' + item.key + '" data-delta="-1" aria-label="Decrease">\u2212</button><span>' + item.quantity + '</span><button data-cd-qty="' + item.key + '" data-delta="1" aria-label="Increase">+</button></div>' +
        '</div>' +
      '</div></div>';
  }

  function renderDrawer(cart) {
    var d = qs('#cartDrawer'); if (!d) return;
    setCounts(cart.item_count);
    var body = qs('#cartDrawerBody'), foot = qs('#cartDrawerFoot');
    if (!cart.item_count) {
      body.innerHTML = '<div class="cartdrawer__empty"><p>Your bag is empty.</p><a href="' + (CFG.shopUrl || '/collections/all') + '" class="cartdrawer__shopbtn">Shop the sale \u2192</a></div>';
      foot.innerHTML = '';
      return;
    }
    var disc = discountFor(cart.item_count);
    var bundleSave = Math.round(cart.items_subtotal_price * disc.off / 100);
    var afterBundle = cart.items_subtotal_price - bundleSave;
    body.innerHTML = bundleProgressHTML(cart, true) + '<div class="cartdrawer__items">' + cart.items.map(drawerLine).join('') + '</div>' +
      '<div class="upsell" id="drawerUpsell"></div>';
    var payTpl = qs('#cartPayMarks');
    var payHTML = payTpl ? payTpl.innerHTML : '';
    foot.innerHTML =
      '<div class="cartdrawer__rows">' +
        (disc.off ? '<div class="cdr disc"><span>Your bundle savings</span><span>\u2212 ' + money(bundleSave) + '</span></div>' : '') +
        '<div class="cdr total"><span>Total</span><b>' + money(afterBundle) + '</b></div>' +
      '</div>' +
      '<a href="/checkout" class="cartdrawer__checkout"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> SECURE CHECKOUT</a>' +
      payHTML;
    loadUpsell('#drawerUpsell', cart);
    /* fetch compare-at prices */
    var handles = [];
    cart.items.forEach(function(it){ if(handles.indexOf(it.handle)===-1) handles.push(it.handle); });
    Promise.all(handles.map(function(h){ return fetchJSON('/products/'+h+'.js'); }))
      .then(function(products){
        var capMap={};
        products.forEach(function(pr){ pr.variants.forEach(function(v){ capMap[v.id]=v.compare_at_price; }); });
        cart.items.forEach(function(it){
          var cap=capMap[it.variant_id];
          if(cap && cap>it.final_price){
            var el=qs('.cdl[data-key="'+it.key+'"] .cdl__price');
            if(el) el.innerHTML='<s>'+money(cap)+'</s> '+money(it.final_price);
          }
        });
      });
  }

  function refreshCart(open) {
    return fetchJSON('/cart.js').then(function (cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart }));
      if (open) openCart();
      return cart;
    });
  }
  function openCart() { var d = qs('#cartDrawer'); if (!d) return; document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { d.classList.add('open'); }); }
  function closeCart() { var d = qs('#cartDrawer'); if (d) d.classList.remove('open'); document.body.style.overflow = ''; }

  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    return fetchJSON('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function () { return refreshCart(!opts.silent); });
  }
  function changeLine(key, qty) {
    return fetchJSON('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (cart) { renderDrawer(cart); document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart })); return cart; });
  }

  /* ---------- upsell ---------- */
  function miniCard(p) {
    var v = p.variants[0];
    var compare = (v.compare_at_price && v.compare_at_price > v.price) ? '<s>' + money(v.compare_at_price) + '</s>' : '';
    var imgSrc = p.featured_image || (p.images && p.images[0]) || '';
    /* ensure Shopify CDN image is sized correctly */
    if (imgSrc && imgSrc.indexOf('cdn.shopify.com') > -1) {
      imgSrc = imgSrc.replace(/(\.[a-z]+)\?/, '_300x$1?');
      if (imgSrc.indexOf('?') === -1 && imgSrc.indexOf('_300x') === -1) {
        imgSrc = imgSrc.replace(/(\.[a-z]+)$/, '_300x$1');
      }
    }
    return '<div class="umini">' +
      '<a href="' + p.url + '"><img class="umini__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" /></a>' +
      '<a class="umini__name" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="umini__price">' + money(v.price) + ' ' + compare + '</div>' +
      '<button class="umini__add" data-add-variant="' + v.id + '">Add to bag</button>' +
    '</div>';
  }
  function loadUpsell(sel, cart) {
    var host = qs(sel); if (!host) return;
    var pid = cart && cart.items && cart.items[0] ? cart.items[0].product_id : null;
    if (!pid) { host.innerHTML = ''; return; }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return p.available; });
        if (!prods.length) { host.innerHTML = ''; return; }
        host.innerHTML = '<div class="upsell__head"><span class="upsell__title">You\'ll also love</span></div>' +
          '<div class="upsell__track">' + prods.map(miniCard).join('') + '</div>';
      }).catch(function () { host.innerHTML = ''; });
  }

  /* ---------- delegated events for cart drawer ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-open-cart]'))) { e.preventDefault(); refreshCart(true); }
    else if ((t = e.target.closest('[data-close-cart]'))) { e.preventDefault(); closeCart(); }
    else if ((t = e.target.closest('[data-checkout]'))) { e.preventDefault(); window.location.href = '/checkout'; }
    else if ((t = e.target.closest('[data-add-variant]'))) { e.preventDefault(); addToCart(t.getAttribute('data-add-variant'), 1); }
    else if ((t = e.target.closest('[data-cd-qty]'))) {
      var line = t.closest('.cdl'); var span = qs('.qty span', line);
      var cur = parseInt(span.textContent, 10); var d = parseInt(t.getAttribute('data-delta'), 10);
      changeLine(t.getAttribute('data-cd-qty'), Math.max(0, cur + d));
    }
    else if ((t = e.target.closest('[data-cd-remove]'))) { changeLine(t.getAttribute('data-cd-remove'), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- intercept ALL cart links ---------- */
  document.addEventListener('click', function (e) {
    var t;
    /* SECURE CHECKOUT link — let it navigate to /checkout */
    if ((t = e.target.closest('.cartdrawer__checkout'))) {
      e.stopPropagation();
      window.location.href = '/checkout';
      return;
    }
    /* Cart icon (.js-drawer-open-cart) */
    if ((t = e.target.closest('.js-drawer-open-cart'))) {
      e.preventDefault();
      e.stopPropagation();
      refreshCart(true);
      return;
    }
    /* Any <a> going to /cart */
    if ((t = e.target.closest('a'))) {
      var href = t.getAttribute('href') || '';
      if (href === '/cart' || href.match(/\/cart(\?|$)/)) {
        e.preventDefault();
        e.stopPropagation();
        refreshCart(true);
        return;
      }
    }
  }, true); /* capture phase — runs before Impulse */

  /* ---------- after Impulse adds product: open Vomaire drawer ---------- */
  document.addEventListener('ajaxProduct:added', function () {
    /* Close Impulse drawer if it opened */
    var impulseDrawer = document.getElementById('CartDrawer');
    if (impulseDrawer) impulseDrawer.classList.remove('drawer--is-open');
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart');
    /* Open Vomaire drawer */
    refreshCart(true);
  });

  /* ---------- /cart page redirect ---------- */
  function redirectCartPage() {
    if (window.location.pathname === '/cart') {
      window.location.replace('/collections/all');
    }
  }

  /* ---------- expose ---------- */
  window.Vomaire = {
    money: money, addToCart: addToCart, refreshCart: refreshCart, openCart: openCart, closeCart: closeCart,
    discountFor: discountFor, bundleProgressHTML: bundleProgressHTML, toast: toast, miniCard: miniCard,
    loadUpsell: loadUpsell, fetchJSON: fetchJSON, BUNDLE: BUNDLE
  };

  /* ---------- init ---------- */
  function init() {
    redirectCartPage();
    refreshCart(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
